export const adcellPid = 13729
